import { Navigate, type RouteObject } from 'react-router-dom';

import { BlogIndexRoute, BlogPostRoute } from '../features/blog';
import { LandingPage } from '../features/landing';
import { NotFoundRoute } from './routes/NotFound';
import { RetiredRoute } from './routes/RetiredRoute';

/**
 * Paths that belonged to the hosted product surface (accounts, the app, chat,
 * billing, workspace invites). They render a closure notice rather than a 404 so
 * old bookmarks and links explain themselves.
 */
export const RETIRED_PATHS = ['/auth/*', '/app/*', '/invite/*', '/pricing'];

export const routes: RouteObject[] = [
  { path: '/', element: <LandingPage /> },
  // `/welcome` was a public alias of the landing page (it sat in the hosted
  // site's sitemap), not product surface, so it redirects rather than closes.
  { path: '/welcome', element: <Navigate to="/" replace /> },
  { path: '/blog', element: <BlogIndexRoute /> },
  { path: '/blog/:slug', element: <BlogPostRoute /> },
  ...RETIRED_PATHS.map((path) => ({ path, element: <RetiredRoute /> })),
  { path: '*', element: <NotFoundRoute /> },
];
